/**
 * @module question responses
 */
import { createReducer, current } from '@reduxjs/toolkit';
import { reportingActions } from '~/behaviors/actions/reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const regenQuestionResponses = (state, action) => {
  const questionResponses = action?.payload?.entities?.questionResponses || {};
  return questionResponses;
};

const mergeQuestionResponses = (state, action) => {
  const questionResponses = action?.payload?.entities?.questionResponses || {};
  const currentState = current(state);

  Object.values(questionResponses).forEach((questionResponse) => {
    const matchedResponse = Object.values(currentState).find(
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      (res) => res.surveyElement === questionResponse.surveyElement,
    );
    if (matchedResponse) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      state[matchedResponse.id] = {
        // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
        ...matchedResponse,
        // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
        ...questionResponse,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        id: matchedResponse.id, // make sure original id doesn't get changed
      };
    }
  });
};

const questionReports = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(reportingActions.fetchQuestionResults.fulfilled, regenQuestionResponses);

  builder.addCase(reportingActions.fetchQuestionAttributeResponses.fulfilled, mergeQuestionResponses);
});

export default questionReports;
